/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { PaymentApi } from "../../../api/PaymentApi";
import Loader from "../../../custom_views/Loader";
import { getRequestParams } from "../../../utils/CookieHelper";
import { getIsDesktop, getUrlParameter, Pages } from "../../../utils/Utils"
import { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import add_card_img from '../../../img/pay/add_card.svg'
import mir_card from '../../../img/pay/mir_card.svg'
const reginaID = "64010cbdc25dca81ca8d6d0a"

const PayoutTinkoffRequest = ({ user, getMyInfo, showToast }) => {
    const [payoutMoney, setPayoutMoney] = useState(user.count_rub ? parseInt(user.count_rub) : 0)
    const [isLoading, setLoading] = useState(false)
    const [isShowCards, setShowCards] = useState(false)
    const [myCards, setMyCards] = useState([])
    const [selectedCard, setSelectedCard] = useState(undefined)
  
    useEffect(() => {
        if (user && user.count_rub != undefined){
            setPayoutMoney(parseInt(user.count_rub))
            const card_added = getUrlParameter("card_added")
            if (card_added){
                setShowCards(true)
            }
        }
    }, [user])
    useEffect(() => {
        if (isShowCards){
            getCardsPayoutTinkof()
        }
    }, [isShowCards])
    const minPayoutSum = user._id == reginaID ? 20 : 5000
    const isMoneyErrorText = (payoutMoney > parseInt(user.count_rub)) ? "Недостаточно средств" : (payoutMoney < minPayoutSum) ? "Минимальная сумма вывода 5 000₽" : ""
    const isDesktop = getIsDesktop()
  

    
    // const isEnableButton = true
    const addPayoutRequest = () => {
        var params = getRequestParams()
        params.amount = payoutMoney
        params.purse = selectedCard.CardId
        params.type = 1
        // params.memberId = isSbpPay ? selectedBank.member_id : "-1"
        console.log("addRequestMoney = ", params)
        setLoading(true)
        PaymentApi.addRequestMoney(params, (responseData) => {
            if (responseData.response > 0){
                getMyInfo()
            }
            console.log("addRequestMoney result = ", responseData)
            setLoading(false)
            window.location.href = Pages.pay + "?payout_sent=1"
        })
    }
    const addCard = () => {
        PaymentApi.addCardToClientTinkof((responseData) => {
            if (responseData.url){
                window.location.href = responseData.url

            }
        })
    }
    const getCardsPayoutTinkof = () => {
        PaymentApi.getCardsPayoutTinkof((responseData) => {
            setMyCards(responseData.cards)
        }, () => {

        })
    }
    const isEnoughMoney = isMoneyErrorText == ""
    const isEnableButton = isShowCards ? (selectedCard != undefined && isEnoughMoney && !isLoading) : isEnoughMoney
    const btnStyle = isEnableButton ? isDesktop ? {position : 'initial', width : 'calc(100% - 32px)', marginTop : isDesktop ? '48px' : ''} : {position : isDesktop ? 'initial' : 'fixed', marginTop : isDesktop ? '48px' : ''} : {pointerEvents : 'none', opacity : '0.2', position : isDesktop ? 'initial' : 'fixed', width : isDesktop ? 'calc(100% - 32px)' : '', marginTop : isDesktop ? '48px' : ''}
    const cardsHTML = () => {
        return(
            <div>
                <div style={{display : 'block'}} className='payout_mobile_title'>{payoutMoney}₽</div>
                <div className='pay_payout_type_title'>Выберите карту:</div>
                <div className="payout_add_card">
                    <div onClick={addCard} className="payout_add_card_inner hover">
                        <img alt='add card' src={add_card_img}/>
                        <p>Добавить новую карту</p>
                    </div>
                    {myCards.length > 0 && myCards.map((card, index) => (
                        <div className="payout_card_item" index={index} key={index}>
                            <div onClick={() => setSelectedCard(selectedCard == card ? undefined : card)} style={selectedCard == card ? {background : 'var(--light-purple)'} : {}} className="payout_add_card_item hover relative">
                                <img className="payout_card_img" alt='selected card' src={mir_card}/>
                                <div className="payout_card_title_item">
                                    <div style={{marginBottom : '8px'}}>
                                        <span style={{color : 'black'}}>Мир</span> *{card.Pan.slice(-4)}
                                    </div>
                                    <div>{card.ExpDate.slice(0, 2)}/{card.ExpDate.slice(-2)}</div>
                                </div>
                                {selectedCard == card && <div className="payout_check_card">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.7428 3.7561C14.0857 4.09757 14.0857 4.65121 13.7428 4.99268L6.42575 12.2439C6.08285 12.5854 5.5269 12.5854 5.184 12.2439L2.25717 9.36462C1.91428 9.02315 1.91428 8.46952 2.25717 8.12805C2.60007 7.78658 3.15602 7.78658 3.49892 8.12805L5.80488 10.389L12.5011 3.7561C12.844 3.41463 13.3999 3.41463 13.7428 3.7561Z" fill="black" />
                                    </svg>
                                </div>}
                            </div>
                        </div>
                    ))}
                </div>
                
                <button style={btnStyle} onClick={addPayoutRequest} className="fill_button hover profile_bottom_button payout_btn_z">{"Заказать выплату"}</button>
                <div className='payout_mobile_gradients'>
                    <div className='payout_mobile_gradient'></div>
                    <div className='payout_mobile_gradient_2'></div>
                </div>
            </div>
        )
    }
    if (isShowCards){
        return cardsHTML()
    }
    return(
        <div>
            <div className='payout_mobile_title'>Вывести заработок</div>
            <div className='pay_payout_type_title'>Сколько выводим</div>
            <div className="input_pay_container">
                <input style={isMoneyErrorText != "" ? {border: '1px solid #FF5353', padding : '15px'} : {}} placeholder="Сумма выплаты" className="pay_input" type="number" value={payoutMoney} onChange={(e) => setPayoutMoney(e.target.value)}/>
                <p className="pay_input_sign pay_input_s">₽</p>
            </div>
            <CSSTransition in={isMoneyErrorText != ""} timeout={300} classNames="animation_in" unmountOnExit>
                <p className="payout_error_text">{isMoneyErrorText}</p>
            </CSSTransition>
        
           
            <div className='pay_comission_calc'>{"Ваша комиссия: 0%"}</div>
            <div className='payout_comissions'>
                • Комиссия: 0%<br/>
                • Минимальная сумма: 5 000₽<br/>
                • Максимальная сумма операции: 75 000 ₽<br/>
                • Максимальная сумма выплат на одни реквизиты в месяц: 400 000 ₽<br/>
                • Ваш запрос будет обработан в течение 3 дней<br/>
                • Внесённые вами через пополнение баланса деньги в лимите не учитываются, вывести через эту форму можно только заработанные средства<br/>
                • Если вы хотите вернуть внесенные средства, то это процедура возврата, оформляется через <span><a className="payout_rules_link_supp" href={Pages.support_chat} target="_blank" rel="noreferrer">поддержку</a></span>.
            </div>
            <br/>
            <a href={Pages.rules} className='payout_rules_link hover'>Правила сервиса</a>

            <button style={btnStyle} onClick={() => setShowCards(true)} className="fill_button hover profile_bottom_button payout_btn_z">{"Дальше"}</button>
            
            <div className='payout_mobile_gradients'>
                <div className='payout_mobile_gradient'></div>
                <div className='payout_mobile_gradient_2'></div>
            </div>
            
        </div>
    )
}
export default PayoutTinkoffRequest